import { Tag } from "antd";
import { TagProps } from "./types";
import styled from "styled-components";
import spacing from "theme/spacing.module.scss";
import colors from "theme/colors.module.scss";

export const StyledTag = styled(Tag)<TagProps>`
    display: inline-flex;;
    gap: ${spacing.spacingXXS};
    width: fit-content;
    min-height: 20px;
    height: fit-content;
    color: ${({ color }) => colors[color] ?? color} !important;
    background-color: ${({ background }) => colors[background] ?? background} !important;
    border: transparent;
    border-radius: 2px;
    padding-right: ${spacing.spacingXXS};
    padding-left: ${spacing.spacingXXS};
    font-weight: 700;
    max-width: 100%;

    svg {
        flex-shrink: 0;
        margin-top: ${spacing.spacingXXS};
        color: ${({ color }) => colors[color]};
}
    .anticon svg {
        margin-top: 0;
    }
`;

export const TagText = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 200px;
`;
